import React, { useState, useEffect } from 'react';
import { Backdrop, CircularProgress, Box } from '@mui/material';

let requestCount = 0;
let setGlobalLoadingState = null;

export const showLoader = () => {
  requestCount++;
  console.log('Loader: showLoader called, requestCount:', requestCount);
  if (setGlobalLoadingState) {
    console.log('Loader: Triggering state update to true');
    setGlobalLoadingState(true);
  } else {
    console.log('Loader: setGlobalLoadingState is NULL!');
  }
};

export const hideLoader = () => {
  requestCount--;
  console.log('Loader: hideLoader called, requestCount:', requestCount);
  if (requestCount <= 0) {
    requestCount = 0;
    setTimeout(() => {
      if (requestCount === 0 && setGlobalLoadingState) {
        console.log('Loader: Triggering state update to false (after delay)');
        setGlobalLoadingState(false);
      }
    }, 300);
  }
};

const GlobalLoader = () => {
  const [loading, setLoading] = useState(requestCount > 0);

  useEffect(() => {
    console.log('Loader: GlobalLoader component mounted, requestCount:', requestCount);
    setGlobalLoadingState = setLoading;
    if (requestCount > 0) {
      console.log('Loader: Request active on mount, setting loading to true');
      setLoading(true);
    }
    return () => {
      console.log('Loader: GlobalLoader component unmounting');
      setGlobalLoadingState = null;
    };
  }, []);

  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: 99999, 
        backgroundColor: 'transparent',
        pointerEvents: 'none'
      }}
      open={loading}
      transitionDuration={0}
    >
      <Box 
        sx={{ 
          position: 'fixed', 
          top: '20px', 
          right: '20px', 
          pointerEvents: 'none',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid rgba(0, 0, 0, 0.05)'
        }}
      >
        <CircularProgress size={20} color="primary" disableShrink />
      </Box>
    </Backdrop>
  );
};

export default GlobalLoader;
